import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppState } from '../state/app.state';
import { AppInformationService } from './app-info.service';

@Injectable()
export class CookiesConfigService {

	constructor(private store: Store, private appInfo: AppInformationService) {
	}

	get ConfigCookies(): { resolvePath: boolean, useCloudfront: boolean } {
		const state = this.store.selectSnapshot(AppState.getAppState);
		return state[this.appInfo.appName].cookieEnable ? {
			resolvePath: true,
			useCloudfront: false
		} : {resolvePath: false, useCloudfront: true}
	}
}
